import { sendStats } from './stats';

export const wideo = (el) => {

	if (!(el instanceof Element)) return;

	let index = document.querySelectorAll('.player[data-index]').length;
	el.dataset.index = index;
	el.setAttribute('id', `player_${index}`);

	const url = el.getAttribute('data-url');

	function initPlayer() {
		let playerInitialized = false;
		const statsQuadrantsPos = {};
		let clipName;
		let clipMid;
		let player = new WP.player({
			url: url,
			target: `player_${index}`,
			adv: false,
			hiderelated: true,
			extendedrelated: false,
			floatingplayer: false,
			autoplay: false,
			forceliteembed: false
		});

		const statsQuadrants = (p) => {
			p = Math.round(p * 100);
			if (!statsQuadrantsPos[clipMid]) {
				statsQuadrantsPos[clipMid] = {};
			}
			if (p >= 25 && p < 50) {
				if (!statsQuadrantsPos[clipMid][25]) {
					statsQuadrantsPos[clipMid][25] = 1;
					sendStats('video', 'quarter=25', clipName);
					// console.log("video", "quarter=25", clipName);
				}
			} else if (p >= 50 && p < 75) {
				if (!statsQuadrantsPos[clipMid][50]) {
					statsQuadrantsPos[clipMid][50] = 1;
					sendStats('video', 'quarter=50', clipName);
					// console.log("video", "quarter=50", clipName);
				}
			} else if (p >= 75 && p < 100) {
				if (!statsQuadrantsPos[clipMid][75]) {
					statsQuadrantsPos[clipMid][75] = 1;
					sendStats('video', 'quarter=75', clipName);
					// console.log("video", "quarter=75", clipName);
				}
			}
		};
		player.on('INIT', () => {
			if (!playerInitialized) {
				playerInitialized = true;
				player.setVolume(0.5);
			}
		});
		player.on('START_MOVIE', () => {
			clipName = player.getClipData().title;
			clipMid = player.getClipData().mid;
			sendStats('video', 'view', clipName);
			// console.log("video", "view", clipName);

			// dot na start wideo to tu
			// const myImage = new Image(0,0);
			// myImage.src = "";          
		});
		player.on('END_MOVIE', () => {
			sendStats('video', 'end', clipName);
			// console.log("video", "end", clipName);
		});
		player.on('UPDATE_POSITION', (e) => {
			const position = player.getPosition();
			statsQuadrants(position);
		});

	};
	(window.WP = window.WP || []).push(initPlayer);
};
